import type { StatusEffect, StatusKind } from './types';

export function applyStatus(list: StatusEffect[], next: StatusEffect): void {
  const existing = list.find((s) => s.kind === next.kind);
  if (!existing) {
    list.push({ ...next });
    return;
  }
  existing.magnitude = Math.max(existing.magnitude, next.magnitude);
  existing.remaining = Math.max(existing.remaining, next.remaining);
}

/** Advance every status; returns the damage-over-time (burn + poison) dealt this tick. */
export function tickStatuses(list: StatusEffect[], dt: number): number {
  let dotDamage = 0;
  for (const s of list) {
    const active = Math.min(dt, s.remaining);
    if (s.kind === 'burn' || s.kind === 'poison') dotDamage += s.magnitude * active;
    s.remaining -= dt;
  }
  for (let i = list.length - 1; i >= 0; i--) if (list[i].remaining <= 0) list.splice(i, 1);
  return dotDamage;
}

const strongest = (list: StatusEffect[], kind: StatusKind): number =>
  list.filter((s) => s.kind === kind).reduce((m, s) => Math.max(m, s.magnitude), 0);

export const slowFactor = (list: StatusEffect[]): number => 1 - strongest(list, 'slow');
export const vulnerabilityBonus = (list: StatusEffect[]): number => strongest(list, 'vulnerable');
